import { SearchParams, formatDateForApi } from '@/shared/lib';
import type { Pagination } from '@/shared/lib';
import api from '@/shared/api';

type ApiQueryParamValue = string | number | boolean | string[];

export interface PaginatedSearchApiResult<TItem = unknown> {
  data: TItem[];
  metadata: Pagination;
}

export default async function search<TResponse extends PaginatedSearchApiResult = PaginatedSearchApiResult>(
  endpoint: string,
  params: SearchParams
): Promise<TResponse> {
  const { searchUrl, search, amount, sort, filter, ...rest } = params;
  void searchUrl;

  const cleanedFilter = Object.entries(filter).reduce<Record<string, ApiQueryParamValue>>(
    (acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        if (typeof value === 'number' && value === 0) {
          return acc;
        }

        if (value instanceof Date) {
          const formatted = formatDateForApi(value);
          if (formatted !== null) {
            acc[key] = formatted;
          }
        } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          acc[key] = value;
        }
      }
      return acc;
    },
    {}
  );

  const queryParams: Record<string, ApiQueryParamValue | undefined> = {
    ...(rest as Record<string, ApiQueryParamValue | undefined>),
    ...cleanedFilter,
    term: search,
    itemsPerPage: amount,
  };

  if (sort.sort) {
    queryParams.sort = sort.sort;
  }
  if (sort.order) {
    queryParams.order = sort.order;
  }

  const response = await api.get<TResponse>(endpoint, { params: queryParams });
  return response.data;
}
